





























































































































import { Vue, Component } from "vue-property-decorator";

import { EntityHelper, repository } from "@/codes";
import Tooltip from "@/components/Tooltip.vue";
import BaseNote from "@/components/BaseNote.vue";
import TermTree from "@/components/TermTree.vue";

@Component({ components: { TermTree, BaseNote, Tooltip } })
export default class CodeDetails extends Vue {
  get entity() {
    return this.$route.hash
      ? repository.get("codes", this.$route.hash.slice(1))
      : null;
  }

  get tracked() {
    return this.entity ? EntityHelper.track(this.entity) : null;
  }

  get parsed() {
    return this.entity ? EntityHelper.parsed(this.entity) : null;
  }

  hide() {
    this.$router.go(-1);
  }
}
